import { useCallback } from 'react';

import type { GameLaunchProps, GamePopupSource } from '@sunflower-games/analytics-events';
import { useNavigate } from 'react-router-dom';

import { GAME_LAUNCH_TRIGGER } from '../config/constants';
import type { CoinType } from '../stores/cointype/CoinTypeStore';
import { useStores } from '../stores/useStores';

export const useStartGame = () => {
  const navigate = useNavigate();
  const { coinTypeStore, gamesSearchStore, gameStore } = useStores();

  const { coinType: currentCoinType } = coinTypeStore;

  const handleStartGame = useCallback(
    // `source` names the feature (a popup's): it replaces `triggered_by` on game_launch and games_impression.
    (gameId: number, triggered_by: GameLaunchProps['triggered_by'], coinType?: CoinType, source?: GamePopupSource) => {
      if (coinType && coinType !== currentCoinType) {
        coinTypeStore.setCoinType(coinType);
      }

      if (gamesSearchStore.searchTerm) {
        gamesSearchStore.cleanSearch();
      }

      localStorage.setItem(GAME_LAUNCH_TRIGGER, triggered_by);
      gameStore.setLaunchSource(source, gameId);
      navigate('/games/' + gameId);
    },
    [navigate, gamesSearchStore, currentCoinType, coinTypeStore, gameStore],
  );

  return {
    handleStartGame,
  };
};
